import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let reqHeaders: { [k: string]: string } = {};

    // Setting 'product' header to the request only for LOGIN endpoint
    if (req.url.includes('/login')) reqHeaders['product'] = 'mobile';

    const authReq: HttpRequest<any> = req.clone({
      withCredentials: true,
      setHeaders: reqHeaders
    });

    return next.handle(authReq);
  }
}
